(function($) {

	$.fn.msxiCheckboxtree = function(options) {
		// build main options before element iteration
		var opts = $.extend( {}, $.fn.msxiCheckboxtree.defaults, options);

		return this.each(function() {
			var $this = $(this);
			// build element specific options
            var eOpts = $.metadata ? $.extend( {}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend( {}, eOpts, $this.dataset()) : eOpts;

            $this.checkboxTree(eOpts.checkboxtree);


        });
	};
	//
	// plugin defaults
	//
	$.fn.msxiCheckboxtree.defaults = {
		checkboxtree:  {
            initializeChecked:'expanded',
            initializeUnchecked:'collapsed',
            onUncheck: {
                node: 'collapse'
            }
        }
	};

})(jQuery);